import { render, staticRenderFns } from "./SendTest.vue?vue&type=template&id=72129316&scoped=true&"
import script from "./SendTest.vue?vue&type=script&lang=js&"
export * from "./SendTest.vue?vue&type=script&lang=js&"
import style0 from "./SendTest.vue?vue&type=style&index=0&id=72129316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72129316",
  null
  
)

export default component.exports